import { css } from "styled-components";
import { Icon } from "../../../../../../components/Icon";
import { ConsoleButtons } from "../../../ConsoleButtons/components/ConsoleButtons";
export const riotProductSkin = (chroma, paletteTokens) => css `
  .beta-key-module {
    ${chroma.typography.body3};
    display: flex;
    flex-direction: column;

    &_copy {
      .copy-to-clipboard_description,
      .copy-to-clipboard_success {
        color: ${paletteTokens.ctatext1};
        padding-top: 5px;
        padding-bottom: 5px;

        ${Icon} {
          background-color: ${paletteTokens.ctatext1};
        }
      }

      .copy-to-clipboard_item {
        ${chroma.typography.body2};
        font-weight: 600;
      }
    }
  }

  ${ConsoleButtons} {
    .variant-playstation,
    .variant-xbox {
      color: ${paletteTokens.ctatext1};
      width: min-content;
      text-wrap: nowrap;

      ${Icon} {
        background-color: ${paletteTokens.ctatext1};
      }
    }
  }
`;
//# sourceMappingURL=index.js.map